import React,{useState} from "react";
import { useCountdown } from "./useCountdown";
import Time from "./Time";

const Header =()=>{
    const [days,hours,minutes,seconds] = useCountdown();
    if(days+hours+minutes+seconds<=0){
        return "ExpiredNotice";
    }else{
        return(
            <div className="header">
                <div className="launching">
                    WE`RE LAUNCHING SOON
                </div>
                <div className="Show-time">
                    <Time time={days} 
                    title="DAYS"
                    />
                            
                    <Time
                    time={hours} title="HOURS"
                    />
                            
                    <Time 
                    time={minutes} 
                    title="MINUTES"
                    />
                                         
                    <Time 
                    time={seconds}
                    title="SECONDS"
                    />
                </div>
            </div>
                
        )
    }
}
export default Header;
// export default function Header(){
//     return(
//         <div className="header">
//             <div className="launching">
//                 WE`RE LAUNCHING SOON
//             </div>
//             <div className="Show-time">
//                 <Time time={days} 
//                 title="DAYS"
//                 />
                
//                 <Time
//                 time={hours} title="HOURS"
//                 />
                
//                 <Time 
//                 time={minutes} 
//                 title="MINUTES"
//                 />
                             
//                 <Time 
//                 time={seconds}
//                 title="SECONDS"
//                 />
//             </div>
//         </div>
    
//     )
// }